import React from 'react';
import cx from 'classnames';
import Styles from './index.module.scss';

interface IUploadCommonModal {
  children: React.ReactElement;
  title: React.ReactNode;
  onCancel: ()=>void;
  contentClassName?: string;
  headerClassName?: string;
  closeIcon?: React.ReactNode;
}
const CommonModal = ({
  children,
  title,
  contentClassName,
  headerClassName,
  closeIcon,
  onCancel,
}:IUploadCommonModal) => {
  return (
    <div className={Styles.root}>
      <div className={Styles.mask}></div>
      <div className={Styles.contentWrapper}>
        <div className={cx(Styles.content, contentClassName)}>
          <div className={cx(Styles.header, headerClassName)}>
            <div className={Styles.modalTitle}>{title}</div>
            {
              closeIcon ? (
                <div className={Styles.customCloseIcon} onClick={onCancel}>
                  {closeIcon}
                </div>
              ) : (
                <i className={Styles.closeIcon} onClick={onCancel} />
              )
            }
          </div>
          { children }
        </div>
      </div>
    </div>
  );
}

export default CommonModal;